/* eslint-disable react-hooks/exhaustive-deps */
import {
	Box,
	Button,
	Flex,
	FormControl,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Text,
	Tooltip,
	useDisclosure,
} from '@chakra-ui/react';
import { ErrorMessage, Field, FieldArray } from 'formik';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import { useMemo } from 'react';
import RichTextEditorField from '../../../components/form/RichTextEditorField';
import JoditEditor from 'jodit-react';
import jodit from '../../../utils/jodit';
import c from '../../../constant';
import * as Yup from 'yup';
import './style.css';

const validationSchema = Yup.object().shape({
	reference: Yup.string().required('required'),
});

const RichTextEditorFields = ({ name = null, minHeight = 24 }) => {
	const { t } = useTranslation();
	const { isOpen, onOpen, onClose } = useDisclosure();

	const config = useMemo(
		() => ({
			minHeight,
			showPlaceholder: false,
			toolbarSticky: false,
			toolbarAdaptive: false,
			toolbarInlineForSelection: true,
			inline: false,
			readonly: false,
			toolbar: false,
			statusbar: false,
			buttons: jodit?.buttons,
			controls: jodit?.controls,
		}),
		[]
	);

	return (
		<FieldArray name={name}>
			{({ remove, push, form }) => {
				return (
					<>
						<Box width="100%">
							{form?.values[name]?.map((value, i) => (
								<Flex key={i} alignItems="flex-start" mt={1} mb={i === form?.values[name]?.length - 1 ? 0 : 4}>
									<Flex flex={1}>
										<Field name={name + '.' + i}>
											{({ field, meta, form }) => {
												return (
													<FormControl>
														<Flex justifyContent="flex-start" alignItems="center">
															<Box width="100%">
																<JoditEditor
																	value={field?.value}
																	config={config}
																	tabIndex={1}
																	onChange={(newContent) => form?.setFieldValue(name + '.' + i, newContent)}
																/>
																{meta.touched && meta.error && (
																	<ErrorMessage
																		name={name + '.' + i}
																		children={(errorMessage) => (
																			<Text textAlign="left" mt={1} color="red">
																				{t(name)} {t('is')} {t(errorMessage)}
																			</Text>
																		)}
																	/>
																)}
															</Box>
														</Flex>
													</FormControl>
												);
											}}
										</Field>
									</Flex>
								</Flex>
							))}
							{form?.errors[name] && (
								<Flex justifyContent="flex-start" alignItems="center">
									<ErrorMessage
										name={name}
										children={(errorMessage) => (
											<Text textAlign="left" mt={1} color="red">
												{t(name)} {t('is')} {t(errorMessage)}
											</Text>
										)}
									/>
								</Flex>
							)}
							<Flex justifyContent="flex-start" alignItems="center">
								<Tooltip label={t('Add')}>
									<Button
										size="sm"
										colorScheme="blue"
										variant="solid"
										borderRadius={c.borderRadius}
										pl={6}
										pr={6}
										ml={0}
										mr={0}
										mt={form?.values[name]?.length > 0 ? 4 : 0}
										onMouseDown={onOpen}
									>
										{t('Add')}
									</Button>
								</Tooltip>
							</Flex>
						</Box>
						<Modal size="4xl" isOpen={isOpen} onClose={onClose}>
							<ModalOverlay />
							<ModalContent borderRadius={c.borderRadius} pb="2">
								<ModalHeader>{t('Reference')}</ModalHeader>
								<ModalCloseButton />
								<ModalBody>
									<Formik
										initialValues={{ reference: '' }}
										validationSchema={validationSchema}
										onSubmit={(values) => push(values?.reference)}
									>
										{({ values, ...props }) => {
											return (
												<Form>
													<RichTextEditorField name="reference" minHeight={36} />
													<Flex justifyContent="flex-end" alignItems="center" mt={4}>
														<Button type="submit" size="md" pl={8} pr={8}>
															{t('Submit')}
														</Button>
													</Flex>
												</Form>
											);
										}}
									</Formik>
								</ModalBody>
							</ModalContent>
						</Modal>
					</>
				);
			}}
		</FieldArray>
	);
};

export default RichTextEditorFields;
